/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrokerageItemResource } from './brokerageItemResource';


export interface BrokerageResource { 
    currency: BrokerageResource.CurrencyEnum;
    total: number;
    items: Array<BrokerageItemResource>;
}
export namespace BrokerageResource {
    export type CurrencyEnum = 'Kč' | 'Eur';
    export const CurrencyEnum = {
        K: 'Kč' as CurrencyEnum,
        Eur: 'Eur' as CurrencyEnum
    };
}


